import useSWR from "swr";
import { useCreateProductServiceAdminAxiosInstance } from "../../Auth/useCreateProductServiceAdminAxiosInstance.ts";
import { BonificoOrderDTO } from "./BonificoOrderDTO.ts";

export function useBonificoOrder(orderId: string) {
  const { createAxiosInstance } = useCreateProductServiceAdminAxiosInstance();
  const { data, error, isLoading } = useSWR(
    `/bonifico-orders/${orderId}`,
    async (url) => {
      const { data } = await createAxiosInstance().get<BonificoOrderDTO>(url);
      return data;
    },
  );
  return { order: data, error, isLoading };
}
